/* eslint-disable no-unused-vars */
/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export const DATE_FORMAT_LONG_WITH_DAYOFWEEK: Intl.DateTimeFormatOptions = {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
};

export const DATE_FORMAT_SHORT_W_TIME: Intl.DateTimeFormatOptions = {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
};

export const DATE_FORMAT_SHORT_W_TIME_AND_TZ: Intl.DateTimeFormatOptions = {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    timeZoneName: 'short',
};

//Modified from sarsa
export const getDateTimeFormatOptionsFromFormat = (
    format: string,
    showTimeZone?: boolean
): Intl.DateTimeFormatOptions => {
    let options;
    switch (format) {
        case 'l':
            options = {
                dateStyle: 'short',
            };
            break;
        case 'L':
            options = {
                month: '2-digit',
                day: '2-digit',
                year: 'numeric',
            };
            break;
        case 'll':
            options = {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
            };
            break;
        case 'LL':
            options = {
                month: 'long',
                day: 'numeric',
                year: 'numeric',
            };
            break;
        case 'LLL':
            options = {
                month: 'long',
                day: 'numeric',
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                timeZoneName: showTimeZone ? 'short' : undefined,
            };
            break;
        case 'lll':
            options = {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                timeZoneName: showTimeZone ? 'short' : undefined,
            };
            break;
        case 'LLLL':
            options = {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                timeZoneName: showTimeZone ? 'short' : undefined,
            };
            break;
        case 'llll':
            options = {
                weekday: 'short',
                month: 'short',
                day: 'numeric',
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                timeZoneName: showTimeZone ? 'short' : undefined,
            };
            break;
        case 'LT':
            options = {
                hour: 'numeric',
                minute: 'numeric',
                timeZoneName: showTimeZone ? 'short' : undefined,
            };
            break;
        case 'LTS':
            options = {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: showTimeZone ? 'short' : undefined,
            };
            break;

        default:
            throw new Error('FormattedDate received an unknown format');
    }
    return options;
};

export const stringToDate = (value) => {
    //If an empty string (ex. in tests) default to today
    return value ? new Date(value) : new Date();
};
